import { secondsToMilliseconds } from 'date-fns';
import ky from 'ky';

export const baseClient = ky.create({
  prefixUrl: import.meta.env.VITE_API_BASE_URL,
  timeout: secondsToMilliseconds(15),
});
